import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/home_logo.png'
import _imports_1 from '../assets/exit.png'


const _hoisted_1 = { class: "h_content" }
const _hoisted_2 = { class: "tab_cont" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "right_box" }
const _hoisted_6 = { class: "login" }
const _hoisted_7 = {
  key: 0,
  class: "txt"
}
const _hoisted_8 = { class: "none_bg" }
const _hoisted_9 = {
  key: 0,
  class: "popup"
}
const _hoisted_10 = { class: "data_cont" }

import { TempSetUserAuthority } from "@/api/api";
import router from "@/router";
import { useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import { onMounted, reactive, ref } from "vue";
import { AxiosResponse } from "axios";

interface User {
  userName: string;
  authority: number;
}

interface ApiResponse {
  code: number;
  message: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'heard',
  setup(__props) {

const ruleForm = reactive({
  UserName: "",
});
const list = ref([
  {
    name: "首页",
    path: "/home",
  },
  {
    name: "推广返佣",
    path: "/userInfo/Invite",
  },
  {
    name: "商城",
    path: "/userInfo/goods",
  },
  {
    name: "钱包",
    path: "/userInfo/user",
  },
  {
    name: "个人中心",
    path: "/userInfo/security",
  },
]);
const active = ref(0);
const tipName = ref({
  name: "Login",
});

onMounted(() => {
  let url = useRoute().path;
  const newIndex = list.value.findIndex((item) => item.path === url);
  active.value = newIndex;
});

const popupShow = ref(false);
const userInfoString = localStorage.getItem("userinfo");

const userinfo: User | null = userInfoString
  ? (JSON.parse(userInfoString) as User)
  : null;
if (userinfo) {
  tipName.value.name = userinfo.userName;
}

function pupShow() {
  popupShow.value = !popupShow.value;
}

function navGo(n: number, path: string) {
  let token = localStorage.getItem("appToken");
  if (n == 2 || n == 0) {
    active.value = n;
    router.push(path);
    return;
  }
  if (token === "" || token === undefined || token === null) {
    ElMessage({
      message: "请先登录",
      type: "error",
    });
  } else {
    active.value = n;
    router.push(path);
  }
}
function submitF() {
  let data = {
    UserName: ruleForm.UserName,
  };

  TempSetUserAuthority(data).then((res: AxiosResponse<ApiResponse>) => {
    if (res.data.code === 0) {
      ElMessage({
        message: "激活成功",
        type: "success",
      });
      popupShow.value = false;
    } else {
      ElMessage({
        message: res.data.message,
        type: "error",
      });
    }
  });
}

function removeAll() {
  router.push("/login");
  localStorage.removeItem("userinfo");
  ElMessage({
    message: "退出成功",
    type: "success",
  });
  localStorage.removeItem("appToken");
}
const onPushHome = (e: number) => {
  let token = localStorage.getItem("appToken");

  // return
  if (e == 4) {
    if (token === "" || token === undefined || token === null) {
      ElMessage({
        message: "请先登录",
        type: "error",
      });
    } else {
      // location.href = "/project2/index.html#Biz/Square/Index";
      location.href = "/apps/home/index.html#Biz/Square/Index";
    }
  }

  return;
};
function goLogin() {
  if (!userinfo) {
    router.push("login");
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "logo" }, [
        _createElementVNode("img", { src: _imports_0 })
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (navGo(index, item.path)),
            class: _normalizeClass([active.value == index ? 'active' : '', "tab_li btn"]),
            key: index
          }, _toDisplayString(item.name), 11, _hoisted_3))
        }), 128)),
        (_unref(userinfo))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_unref(userinfo).authority !== 9)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "tab_li activea",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (onPushHome(4)))
                  }, " 控制台 "))
                : _createCommentVNode("", true),
              (_unref(userinfo).authority == 9)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "tab_li",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (pupShow()))
                  }, " 管理后台 "))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "tab_li activea",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (onPushHome(4)))
            }, "控制台"))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_unref(userinfo))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createTextVNode(_toDisplayString(tipName.value.name) + " ", 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: "none_icon",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (removeAll()))
                  }, _cache[6] || (_cache[6] = [
                    _createElementVNode("img", { src: _imports_1 }, null, -1),
                    _createElementVNode("div", { class: "name" }, "退出登录", -1)
                  ]))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "txt",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (goLogin()))
              }, "Login"))
        ])
      ])
    ]),
    (popupShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.UserName,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ruleForm.UserName) = $event)),
              placeholder: "请输入用户名称",
              class: "input_st"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", { class: "btn_st" }, [
              _createElementVNode("div", {
                class: "tip_cont",
                onClick: submitF
              }, "激活"),
              _createElementVNode("div", {
                class: "tip_cont",
                onClick: pupShow
              }, "关闭弹窗")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})